import React from "react"
import { Item, Variant } from "../types"

const DEFAULT_ITEMS: Item[] = [
  { title: <>Плата за обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Плата за выпуск</>, text: <>0 ₽</> },
  {
    title: (
      <>
        Возобновляемый кредитный <br /> лимит
      </>
    ),
    text: <>до 500 000 ₽ в течение 5 лет</>,
  },
  {
    title: (
      <>
        Ставка в течение льготного периода <br /> (36&nbsp;мес.)
      </>
    ),
    text: <>0 ₽ годовых</>,
  },
  { title: <>Кэшбэк</>, text: <>до 10%</> },
  { title: <>Выгода</>, text: <>До 5% годовых к&nbsp;ставке вклада</> },
]

const DEBET_ITEMS: Item[] = [
  { title: <>Плата за обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Плата за выпуск</>, text: <>0 ₽</> },
  {
    title: (
      <>
        Возобновляемый кредитный <br /> лимит
      </>
    ),
    text: <>до 500 000 ₽ в течение 5 лет</>,
  },
  {
    title: (
      <>
        Ставка в течение льготного периода <br /> (36&nbsp;мес.)
      </>
    ),
    text: <>0 ₽ годовых</>,
  },
  { title: <>Кэшбэк</>, text: <>до 10% с подпиской «Халва.Десятка»</> },
  { title: <>Выгода</>, text: <>До 5% годовых к&nbsp;ставке вклада</> },
]

const ABOUT_CREDIT_ITEMS: Item[] = [
  { title: <>Выпуск и обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Возобновляемый заемный лимит</>, text: <>До 500 000 рублей</> },
  { title: <>На весь срок рассрочки*</>, text: <>0% годовых</> },
  { title: <>Кэшбэк</>, text: <>до 10%</> },
  { title: <>На остаток своих средств</>, text: <>до 17% доход</> },
]

const CREDIT_CARDS_ITEMS: Item[] = [
  { title: <>Полная стоимость кредита</>, text: <>от 38,380% до 60,757% годовых</> },
  { title: <>Процентная ставка</>, text: <>59,9% годовых</> },
  { title: <>Ставка в течение льготного периода</>, text: <>0% годовых*</> },
  { title: <>Плата за обслуживание</>, text: <>0 ₽</> },
  { title: <>Кредитный лимит</>, text: <>до 500 000 ₽</> },
  { title: <>Беспроцентный период</>, text: <>до 300 дней</> },
  { title: <>Плата за выпуск</>, text: <>0 ₽</> },
  { title: <>Бесконтактная оплата</>, text: <>Mir Pay</> },
  { title: <>Оформление карты</>, text: <>моментально</> },
  { title: <>Минимальный обязательный платёж</>, text: <>8% от суммы задолженности</> },
  { title: <>Комиссия за перевод заёмных денежных средств</>, text: <>5,9% + 590 ₽</> },
  {
    title: <>Снятие наличных за счёт средств установленного лимита кредитования</>,
    text: <>без комиссии</>,
  },
  {
    title: <>Зеленая цена на Ozon</>,
    text: <>cкидка до 30% при оплате любой картой Совкомбанка</>,
  },
]

const PRAVDA_COFFEE_ITEMS: Item[] = [
  { title: <>Полная стоимость кредита</>, text: <>0% — 19,642%</> },
  { title: <>Базовая процентная ставка</>, text: <>0,001%</> },
  {
    title: <>Процентная ставка льготного периода</>,
    text: <>0% для льготных операций, при соблюдении определенных условий возврата задолженности</>,
  },
  { title: <>Плата за обслуживание</>, text: <>0 &nbsp;₽</> },
  { title: <>Возобновляемый кредитный лимит</>, text: <>до&nbsp;500&nbsp;000&nbsp;₽</> },
  { title: <>Кешбэк</>, text: <>до 10%</> },
  {
    title: <>Зеленая цена на&nbsp;Ozon</>,
    text: <>cкидка до&nbsp;30% при оплате любой картой Совкомбанка</>,
  },
  {
    title: <></>,
    text: (
      <>
        Зеленая цена - это специальная сниженная стоимость товара. Она подсвечивается зелёным цветом
        в&nbsp;карточке товара&nbsp;/ корзине в&nbsp;приложении «Ozon» и позволяет мгновенно
        получить скидку до&nbsp;30%. Данная скидка заменит кешбэк, который начисляться не&nbsp;будет
      </>
    ),
  },
]

const BENEFITS_CREDIT_ITEMS: Item[] = [
  { title: <>Кэшбэк за ЖКХ</>, text: <>1%</> },
  { title: <>Кэшбэк в «Яндекс Go»</>, text: <>10%</> },
  { title: <>Выгода </>, text: <>До 5% годовых к ставке вклада</> },
  { title: <>За приведенного друга</>, text: <>До 1000 рублей</> },
  { title: <>На остаток своих средств</>, text: <>Акции от партнеров</> },
  { title: <>Курьером по удобному адресу</>, text: <>Бесплатная доставка</> },
  { title: <>Еще больше выгоды</>, text: <>Программа лояльности</> },
]

const REFIN_CONDITIONS_ITEMS: Item[] = [
  { title: <>Полная стоимость кредита</>, text: <>0% - 19,642%</> },
  { title: <>Срок рассрочки*</>, text: <>до 24 месяцев</> },
  { title: <>Документы</>, text: <>нужен только паспорт</> },
  { title: <>Одобрение</>, text: <>в день обращения</> },
  { title: <>Плата за выпуск и обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Досрочное погашение задолженности</>, text: <>бесплатно</> },
]

const PKW_REFIN_CONDITIONS_ITEMS: Item[] = [
  { title: <>Полная стоимость кредита</>, text: <>0% - 19,642%</> },
  { title: <>Срок рассрочки*</>, text: <>до 24 месяцев</> },
  { title: <>Документы</>, text: <>нужен только паспорт</> },
  { title: <>Одобрение</>, text: <>в день обращения</> },
  { title: <>Пополнение с карт ПАО &quot;Совкомбанк&quot;</>, text: <>бесплатно</> },
  { title: <>Плата за выпуск и обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Досрочное погашение задолженности</>, text: <>бесплатно</> },
]

const PRODUCT_CATEGORIES_ITEMS: Item[] = [
  {
    title: (
      <>
        Полная стоимость кредита 0% годовых при выполнении условий погашения предоставленной
        рассрочки* в течение льготного периода кредитования
      </>
    ),
    text: <></>,
  },
  { title: <>Рассрочка*</>, text: <>до 24 месяцев</> },
  { title: <>Возобновляемый кредитный лимит</>, text: <>до 500 000 рублей в течении 5 лет</> },
  { title: <>Плата за обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Плата за выпуск</>, text: <>0 ₽</> },
  { title: <>Кэшбэк</>, text: <>до 10% с подпиской «Халва.Десятка»</> },
  { title: <>Выгода</>, text: <>до 5% годовых к ставке вклада</> },
  { title: <>Пополнение</>, text: <>Бесплатно</> },
  { title: <>Досрочное погашение задолжнности</>, text: <>Бесплатно</> },
  { title: <>СМС и Push-уведомления</>, text: <>Бесплатно</> },
]

const TARIFFS: Item[] = [
  { title: <>Плата за обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Плата за выпуск</>, text: <>0 ₽</> },
  {
    title: (
      <>
        Возобновляемый кредитный <br /> лимит
      </>
    ),
    text: <>до 500 000 ₽ в течение 5 лет</>,
  },
  {
    title: <>Беспроцентный период</>,
    text: <>До 10 месяцев</>,
  },
  { title: <>Пополнение</>, text: <>Бесплатно</> },
  {
    title: <>Снятие наличных</>,
    text: <>Бесплатно в рассрочку* на 3 месяца с подпиской «Халва.Десятка»</>,
  },
  {
    title: <>Досрочное погашение задолженности</>,
    text: <>Бесплатно</>,
  },
  {
    title: <>Переводы заемных средств</>,
    text: <>Без комиссии в рассрочку* на 3 месяца с подпиской «Халва.Десятка»</>,
  },
  { title: <>Минимальный платеж</>, text: <>3,9% от задолженности</> },
  { title: <>СМС или Push-уведомления</>, text: <>Бесплатно</> },
]

const ABOUT_CREDIT_WITHOUT_PERCENT = [
  { title: <>Беспроцентный период</>, text: <> до 24 месяцев</> },
  { title: <>Возобновляемый кредитный лимит</>, text: <>до 500 000 ₽ в течение 5 лет</> },
  { title: <>Общая сумма рефинансирования</>, text: <>до 300 000 рублей</> },
  { title: <>Кэшбэк</>, text: <>до 10% с подпиской «Халва.Десятка»</> },
  { title: <>Процент на остаток </>, text: <>до 17% годовых с подпиской «Халва.Десятка»</> },
  { title: <>Плата за обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Плата за выпуск</>, text: <> 0 ₽</> },
  { title: <>Пополнение </>, text: <>бесплатно</> },
  { title: <>Досрочное погашение задолженности</>, text: <>бесплатно</> },
  { title: <>СМС или Push-уведомления</>, text: <>бесплатно</> },
]
const PROCENTY_VERNET_MAGAZIN = [
  { title: <>Срок рассрочки*</>, text: <> до 24 месяцев</> },
  { title: <>Возобновляемый кредитный лимит</>, text: <>до 500 000 ₽ в течение 5 лет</> },
  { title: <>Общая сумма рефинансирования</>, text: <>до 300 000 рублей</> },
  { title: <>Кэшбэк</>, text: <>до 10% с подпиской «Халва.Десятка»</> },
  { title: <>Выгода</>, text: <>до 5% годовых к ставке вклада</> },
  { title: <>Плата за обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Плата за выпуск</>, text: <> 0 ₽</> },
  { title: <>Пополнение </>, text: <>бесплатно</> },
  { title: <>Досрочное погашение задолженности</>, text: <>бесплатно</> },
  { title: <>СМС или Push-уведомления</>, text: <>бесплатно</> },
]

const ABOUT_CREDIT_WITHOUT_PERCENT_36_MONTH = [
  { title: <>Беспроцентный период</>, text: <> до 36 месяцев</> },
  { title: <>Возобновляемый кредитный лимит</>, text: <>до 500 000 ₽ в течение 5 лет</> },
  { title: <>Кэшбэк</>, text: <>до 10% с подпиской «Халва.Десятка»</> },
  { title: <>Процент на остаток </>, text: <>до 17% годовых с подпиской «Халва.Десятка»</> },
  { title: <>Плата за обслуживание</>, text: <>0 ₽ в год</> },
  { title: <>Плата за выпуск</>, text: <> 0 ₽</> },
  { title: <>Пополнение </>, text: <>бесплатно</> },
  { title: <>Досрочное погашение задолженности</>, text: <>бесплатно</> },
  { title: <>СМС или Push-уведомления</>, text: <>бесплатно</> },
]

const STICKER: Item[] = [
  {
    title: <>Плата за обслуживание</>,
    text: (
      <>
        Для ребёнка — 599&nbsp;₽ выпуск, <br />
        0&nbsp;₽ обслуживание
        <br />
        <br />
        Для взрослого — 599&nbsp;₽ выпуск, <br />
        0₽ обслуживание <br />
        <span style={{ fontWeight: 400 }}>
          при наличии Подписки или&nbsp;при ежемесячном совершении стикером от&nbsp;10&nbsp;покупок
          на&nbsp;общую сумму от&nbsp;20&nbsp;000&nbsp;₽ (иначе комиссия 999&nbsp;₽ единоразово).
        </span>
      </>
    ),
  },
  {
    title: <>Кэшбэк</>,
    text: (
      <>
        По детскому стикеру «Халвау»&nbsp;-&nbsp;до&nbsp;5%; <br />
        По стикеру «Халва» - до&nbsp;10% <br className="d-sm-none" />
        с&nbsp;подпиской «Халва.Десятка»
      </>
    ),
  },
]

export const items: Record<Variant, Item[]> = {
  aboutCredit: ABOUT_CREDIT_ITEMS,
  benefitsCredit: BENEFITS_CREDIT_ITEMS,
  refinСonditions: REFIN_CONDITIONS_ITEMS,
  pkwRefin: PKW_REFIN_CONDITIONS_ITEMS,
  tariffs: TARIFFS,
  standard: DEFAULT_ITEMS,
  aboutCardWithoutPercent: ABOUT_CREDIT_WITHOUT_PERCENT,
  procentyVernetMagazin: PROCENTY_VERNET_MAGAZIN,
  aboutCardWithoutPercent36month: ABOUT_CREDIT_WITHOUT_PERCENT_36_MONTH,
  debet: DEBET_ITEMS,
  productCategories: PRODUCT_CATEGORIES_ITEMS,
  sticker: STICKER,
  creditCards: CREDIT_CARDS_ITEMS,
  pravdaCoffee: PRAVDA_COFFEE_ITEMS,
}
